import { useMemo } from 'react';

import moment from 'moment';
import { DatePickerPreset } from 'twyne-new.ui'

import appStore from 'stores/app.js';

export default function DateTimeRange({ value, ...props }) {
  const range = useMemo(() => value || {
    $gte: moment.tz(appStore.timezone).startOf('day'),
    $lte: moment.tz(appStore.timezone).endOf('day'),
  }, [value])

  return <DatePickerPreset
    value={range}
    numberOfMonths={2}
    mask="MM/DD/YYYY"
    {...props}
  />
}
